import { useState } from "react";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import GameList from "../../components/GameList";
import ChatBox from "../../components/ChatBox";
import "./HomePage.css";

const HomePage = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  return (
    <div className="w-full h-screen p-8 flex justify-center items-center">
      {/* <Header setIsShowLogout={() => setIsShowLogout(true)} /> */}
      <GameList />

      {/* Chat Box */}
      <ChatBox />

      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default HomePage;
